import styled from "styled-components";

export const PaymentMethodsContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;

export const PaymentMethodsContentCard = styled.div`
  background-color: white;
  box-sizing: border-box;
  border: ${props => props.isToggled ? '1px solid #92c73c' : '1px solid #E8E8E8'};
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  min-width: 100px;
  width:100%;
  height: 105px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 16px;
  margin-right: 7px;
  & div {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media(max-width: 500px){
    height: 70px;
    & div{
      margin: 0;
    }
  }
  @media(min-height: 650px) {
    padding: 13px 16px;
    min-width: 140px;
    display: flex;
    min-height: 70px;
    flex-direction: column;

  }
  &:last-child {
    margin-right: 0;
  }

`;

export const Logo = styled.img`
  max-width: ${props => 'googlePay' === props?.method ? '60px': '50px'};
  width: 100%;
  display: block;
`

export const PaymentMethodsContentCardText = styled.p`
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 7px;
  @media(max-width: 500px){
    margin: 0;
  }
  text-align: center;
`;